"use client";
import { useEffect, useState } from "react";
import { Storage } from "@/utils/storage";
import userInfoStore from "@/store/userInfoStore";

export const RegisterModal = () => {
  const [open, setOpen] = useState(false)
  const { userInfo } = userInfoStore();

  useEffect(() => {
    // 已登录，则不展示注册弹窗
    if(userInfo?.email) {
      return
    }
    let setTimeoutId: any = null
    if(Storage.getItem("register-modal") !== 1) {
      setTimeoutId = setTimeout(() => {
        if(userInfo?.email) {
          return
        }
        setOpen(true)
        Storage.setItem("register-modal", 1)
      }, 20 * 1000)
    }
    
    return () => {
      setTimeoutId && clearTimeout(setTimeoutId)
    }
  }, [])
  // return <Coupon type={CouponType.REGISTER} open={open} onClose={() => setOpen(false)} />
  return null
}

export default RegisterModal